import { useState, useEffect, useCallback } from 'react';
import { imageAPI } from '../services/api';

export interface CarouselImage {
  _id: string;
  filename: string;
  originalName: string;
  path: string;
  url: string;
  size: number;
  mimeType: string;
  width?: number;
  height?: number;
  category: 'carousel';
  position: number;
  alt?: string;
  description?: string;
  isActive: boolean;
  tags?: string[];
  uploadedBy: {
    _id: string;
    username: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

interface UseCarouselReturn {
  carouselImages: CarouselImage[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useCarousel = (): UseCarouselReturn => {
  const [carouselImages, setCarouselImages] = useState<CarouselImage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCarouselImages = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await imageAPI.getCarouselImages();
      setCarouselImages((response as any)?.data || []);
    } catch (err) {
      console.error('获取轮播图失败:', err);
      setError('获取轮播图失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCarouselImages();
  }, [fetchCarouselImages]);

  return {
    carouselImages,
    loading,
    error,
    refetch: fetchCarouselImages,
  };
}; 